<template>
    <div>
        <side-container :isLoading="isLoading"
            headerTitle="订单详情"
            width="450"
            :isShowFooter="get(rowData, 'refund_orders.length') === 0 && fixNumPro(get(rowData, 'actual_payment')) > 0"
            :isShowFooterBtn="false"
            v-if="visible"
            @close="$emit('update:visible', false)">
            <template v-if="rowData != null">
                <!-- header -->
                <span slot="header">订单编号：{{ get(rowData, 'order_no') }}</span>
                <!-- section -->
                <section v-if="rowData.payment_method == null || rowData.payment_method === 1"
                    class="section">
                    <!-- 已退款 -->
                    <i class="iconfont iconyituikuan" v-if="get(rowData, 'refund_orders.length') > 0"/>
                    <!-- 用户信息 -->
                    <div class="user-info-and-time">
                        <user-info :userInfo="get(rowData, 'creator.user')" maxWidth="calc(100% - 150px)"/>
                        <span class="time">{{ get(rowData, 'create_time') }}</span>
                    </div>
                    <!-- 会员信息 -->
                    <order-form-template headerTitle="会员信息" v-if="rowData.member && rowData.member.id != null">
                        <order-form-item :rightContent="`手机：${rowData.member.phone}`"
                            :showDashedBottomLine="false">
                            <user-info slot="left"
                                maxWidth="240px"
                                :userInfo="{
                                    avatar: rowData.member.user.avatar,
                                    nickname: rowData.member.user.nickname,
                                    realname: rowData.member.name,
                                    gender: rowData.member.user.gender
                                }" />
                        </order-form-item>
                    </order-form-template>
                    <!-- 商品信息 -->
                    <order-form-template headerTitle="商品信息"
                        :showBorder="false"
                        v-if="goodsList.length > 0">
                        <el-table :data="realParticipateDiscountGoods">
                            <el-table-column
                                label="商品名"
                                max-width="150">
                                <template v-slot="{ row }">
                                    <span class="text-popper" v-textPopper>{{ get(row, 'goods.name') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                label="数量"
                                width="90">
                                <template v-slot="{ row }">
                                    <span class="text-popper" v-textPopper>{{ get(row, 'amount') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                label="单价"
                                min-width="100">
                                <template v-slot="{ row }">
                                    <!-- <p class="text-popper member-price" v-textPopper>
                                        <span v-if="get(row, 'member_price.id')">
                                            <span>￥{{ get(row, 'member_price.sale_price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                            <i class="iconfont iconhuiyuanjia" />
                                            <span class="under-line">￥{{ get(row, 'price') }}</span>
                                        </span>
                                        <span v-else>￥{{ get(row, 'price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                    </p> -->
                                    <span>￥{{ get(row, 'price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="right"
                                label="小计"
                                min-width="80">
                                <template v-slot="{ row }">
                                    <span class="text-popper" v-textPopper>￥<span v-numberAlign>{{ get(row, 'subtotal').toFixed(2) }}</span></span>
                                </template>
                            </el-table-column>
                            <template slot="append">
                                <template v-if="realNoParticipateDiscountGoods.length > 0">
                                    <div class="no-participate-text fs-12 align-c color-999">
                                        <span>以下商品不参与优惠 ({{ noParticipateDiscountGoods.length }})</span>
                                    </div>
                                    <el-table :data="realNoParticipateDiscountGoods"
                                        :show-header="false">
                                        <el-table-column
                                            label="商品名"
                                            max-width="150">
                                            <template v-slot="{ row }">
                                                <span class="text-popper" v-textPopper>{{ get(row, 'goods.name') }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            align="center"
                                            label="数量"
                                            width="90">
                                            <template v-slot="{ row }">
                                                <span class="text-popper" v-textPopper>{{ get(row, 'amount') }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            align="center"
                                            label="单价"
                                            min-width="100">
                                            <template v-slot="{ row }">
                                                <!-- <p class="text-popper member-price" v-textPopper>
                                                    <span v-if="get(row, 'member_price.id')">
                                                        <span>￥{{ get(row, 'member_price.sale_price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                                        <i class="iconfont iconhuiyuanjia" />
                                                        <span class="under-line">￥{{ get(row, 'price') }}</span>
                                                    </span>
                                                    <span v-else>￥{{ get(row, 'price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                                </p> -->
                                                <span>￥{{ get(row, 'price') }}/{{ get(row, 'sale_price.sale_unit.name') }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            align="right"
                                            label="小计"
                                            min-width="80">
                                            <template v-slot="{ row }">
                                                <span class="text-popper" v-textPopper>￥<span v-numberAlign>{{ get(row, 'subtotal') }}</span></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <div class="table-append-more-than-five">
                                    <span>{{ get(rowData, 'goods_list.length') }}件商品，总计￥{{ fixNumPro(get(rowData, 'subtotal')) }}</span>
                                    <span class="see-more" v-if="get(rowData, 'goods_list.length') > 5">
                                        <span v-if="isExpandTable === false" @click="isExpandTable = true">查看更多 <i class="iconfont icongonggongxia1"/></span>
                                        <span v-if="isExpandTable === true" @click="isExpandTable = false">收起 <i class="iconfont icongonggongshang1"/></span>
                                    </span>
                                </div>
                            </template>
                        </el-table>
                    </order-form-template>
                    <!-- 收款信息 -->
                    <order-form-template headerTitle="收款信息" v-if="Object.keys(rowData).length > 0">
                        <div class="show-bottom-dashed-border">
                            <order-form-item :leftContent="'商品总价'"
                                :rightContent="`￥${fixNumPro(get(rowData, 'subtotal'))}`"
                                :showDashedBottomLine="false"/>
                            <order-form-item :leftContent="`整单折扣 (${fixNumPro(get(rowData, 'deal.discount_rate') * 10)}折)`"
                                :rightContent="`-￥${fixNumPro(get(rowData, 'deal.discount_amount'))}`"
                                :showDashedBottomLine="false"
                                v-if="get(rowData, 'deal.discount_rate') != 1 && get(rowData, 'deal.deal_type') === 1"/>
                            <order-form-item :leftContent="`会员日折扣 (${fixNumPro(get(rowData, 'member_discount_rate') * 10)}折)`"
                                :rightContent="`-￥${fixNumPro(get(rowData, 'member_discount_amount'))}`"
                                :showDashedBottomLine="false"
                                v-if="get(rowData, 'member_discount_rate') != 1"/>
                            <order-form-item :leftContent="`整单减免`"
                                :rightContent="`-￥${fixNumPro(get(rowData, 'deal.discount_amount'))}`"
                                :showDashedBottomLine="false"
                                v-if="get(rowData, 'deal.discount_amount') != 0 && get(rowData, 'deal.deal_type') === 2"/>
                            <order-form-item :leftContent="'抹零'"
                                :rightContent="`-￥${fixNumPro(get(rowData, 'deal.round_down_amount'))}`"
                                :showDashedBottomLine="false"
                                v-if="get(rowData, 'deal.round_down_amount') != 0"/>
                            <template v-if="getUsedPoints()">
                                <order-form-item :leftContent="`积分抵现（-${getUsedPoints().points}分）`"
                                :rightContent="`-￥${getUsedPoints().amount_deducted}`"
                                :showDashedBottomLine="false"
                                />
                            </template>
                        </div>
                        <div class="show-bottom-dashed-border">
                            <order-form-item :lineHeight="1.5" height="60px" :showDashedBottomLine="false">
                                <span  slot="left">
                                    <div class="column">
                                        <span class="fw-600">应付金额</span>
                                        
                                        <span class="color-999 fz-12" v-if="getGiftPoints()">
                                            本次积分+{{getGiftPoints().points}} <span v-if="getGiftPoints().points_multiplier > 0" class="point-bg" style="color: #8D6549;">{{getGiftPoints().points_multiplier}}倍</span>
                                        </span>
                                    </div>
                                </span>
                                <span class="fw-600" slot="right">￥{{ fixNumPro(get(rowData, 'subtotal') - get(rowData, 'member_discount_amount') - get(rowData, 'deal.discount_amount')- get(rowData, 'deal.round_down_amount') - (getUsedPoints() ? get(getUsedPoints(), 'amount_deducted') : 0)) }}</span>
                            </order-form-item>
                            <!-- <template v-if="changeMoney != 0">
                                <order-form-item :leftContent="'收款金额'"
                                    :rightContent="`￥${get(rowData, 'actual_payment').toFixed(2)}`"
                                    :showDashedBottomLine="false"/>
                                <order-form-item :leftContent="'找零金额'"
                                    :rightContent="`￥${fixNumPro(changeMoney)}`"
                                    :showDashedBottomLine="false"/>
                            </template> -->
                        </div>
                        <order-form-item :showDashedBottomLine="false"
                            :height="'44px'">
                            <span class="fw-600" slot="left">实付金额</span>
                            <div class="align-r" slot="right">
                                <p class="fw-600 color-green" style="line-height: 28px">￥{{ fixNumPro(get(rowData, 'actual_payment')) }}</p>
                                <p  v-if="getPaymentTypeText"
                                    class="fs-12 color-999"
                                    style="line-height: 16px">{{ getPaymentTypeText }}</p>
                            </div>
                            <!-- <span v-else
                                class="fw-600 color-green"
                                slot="right">￥{{ fixNumPro(get(rowData, 'payments[0].payment_amount')) }} <span class="fw-400">({{ getPaymentTypeText }})</span></span> -->
                        </order-form-item>
                    </order-form-template>
                    <!-- 退款信息 -->
                    <order-form-template headerTitle="退款信息" v-if="get(rowData, 'refund_orders.length') > 0">
                        <order-form-item :leftContent="'退款金额'">
                            <span slot="right">￥{{ refundMoneySum }}</span>
                        </order-form-item>
                        <order-form-item :leftContent="'退款时间'"
                            :rightContent="get(rowData, 'refund_orders[0].create_time')"/>
                        <order-form-item :leftContent="'退款人'">
                            <user-info slot="right"
                                :userInfo="get(rowData, 'refund_orders[0].creator.user')"  maxWidth="250px"/>
                        </order-form-item>
                    </order-form-template>
                    <order-form-template v-if="rowData.remark" headerTitle="商家备注" :showBorder="false">
                        <p class="notes">{{rowData.remark}}</p>
                    </order-form-template>
                </section>
                <section v-else class="section">
                    <i class="iconfont iconyituikuan" v-if="get(rowData, 'refund_orders.length') > 0"/>
                    <div class="user-info-and-time">
                        <user-info :userInfo="get(rowData, 'creator.user')" maxWidth="calc(100% - 150px)"/>
                        <span class="time">{{ get(rowData, 'create_time') }}</span>
                    </div>
                    <order-form-template headerTitle="收款信息">
                        <order-form-item :leftContent="'实付金额'"
                            :showDashedBottomLine="false">
                            <span class="fs-16 fw-600 color-green" slot="right">{{ `￥${fixNumPro(get(rowData, 'actual_payment'))} (${getPaymentTypeText})` }}</span>
                        </order-form-item>
                    </order-form-template>
                    <order-form-template v-if="rowData.remark" headerTitle="商家备注" :showBorder="false">
                        <p class="notes">{{rowData.remark}}</p>
                    </order-form-template>
                </section>
                <!-- footer -->
                <div class="footer-btn-wrapper" slot="footer" @click="refundMoney">
                    <span class="iconfont icontuikuan"/>
                    <span>退款</span>
                </div>
            </template>
        </side-container>
        <!-- component -->
        <refund-dialog :rowData="rowData" :visible.sync="isShowRefundDialog" @confirm="refundConfirm"/>
    </div>
</template>

<script>
import SideContainer from '@/components/layout/side-container-style2.vue'
import OrderFormTemplate from './modules/order_form_template.vue'
import OrderFormItem from './modules/order_form_item.vue'
import RefundDialog from '../modules/refund_dialog.vue'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { fixNumPro, getSum, setObjectItemToFixed, getPaymentsText } from '@/utils/index'
import { openMessage } from '../../../utils/system'
import $fetch from '../../../api'

export default {
    data() {
        return {
            isLoading: false,
            isExpandTable: false,
            isShowRefundDialog: false,
            rowData: null
        }
    },
    props: {
        visible: Boolean,
        orderNo: {
            type: String,
            required: true
        }
    },
    computed: {
        participateDiscountGoods() {
            const goodsList = this.rowData.goods_list || []
            return goodsList.filter((goods) => goods.participate_discount === 1 && goods.price == get(goods, 'sale_price.sale_price'))
        },
        noParticipateDiscountGoods() {
            const goodsList = this.rowData.goods_list || []
            return goodsList.filter((goods) => goods.participate_discount === 0 || (goods.participate_discount === 1 && goods.price != get(goods, 'sale_price.sale_price')))
        },
        realParticipateDiscountGoods() {
            if (this.isExpandTable) {
                return this.participateDiscountGoods
            } else {
                return this.participateDiscountGoods.slice(0, 5)
            }
        },
        realNoParticipateDiscountGoods() {
            if (this.isExpandTable) {
                return this.noParticipateDiscountGoods
            } else {
                const len = this.realParticipateDiscountGoods.length
                return this.noParticipateDiscountGoods.slice(0, 5 - len)
            }
        },
        get() {
            return function(...args) {
                const result = get(...args)
                if (/^\d+\.\d+$/.test(result)) {
                    return +(result)
                } else {
                    return result
                }
            }
        },
        goodsList() {
            return this.participateDiscountGoods.concat(this.noParticipateDiscountGoods)
        },
        composePaymentText() {
            if (Object.prototype.toString.call(this.rowData.payments) !== '[object Array]') {
                return ''
            }
            return this.rowData.payments.reduce((next, prev) => {
                next.push(`${prev.payment_type_text}￥${fixNumPro(prev.payment_amount)}`)
                return next
            }, []).join(' | ')
        },
        refundMoneySum() {
            if (Object.prototype.toString.call(this.rowData.refund_orders) !== '[object Array]') {
                return ''
            }
            return fixNumPro(this.rowData.refund_orders.reduce((next, prev) => {
                next += +prev.refund_money
                return next
            }, 0))
        },
        getPaymentTypeText() {
            if (this.rowData == null) {
                return ''
            }
            return getPaymentsText(this.rowData.payments, ' | ', true)
        },
        fixNumPro() {
            return fixNumPro
        },
        getSum() {
            return getSum
        }
    },
    methods: {
        getOrderFormList() {
            this.isLoading = true
            $fetch.post({
                url: '/order/orderdatalist',
                params: {
                    page: 1,
                    limit: 20,
                    order_no: this.orderNo
                }
            }).then(data => {
                console.log('订单详情', clone(data.orders[0]))
                this.isLoading = false
                this.rowData = setObjectItemToFixed(data.orders[0], { ignore: ['discount_rate', 'member_discount_rate'] })
            }).catch(e => openMessage('error', e.message || '获取订单列表失败'))
        },
        // 退款
        refundMoney() {
            if (!this.$store.getters['shop/canIUse'](9)) {
                return openMessage('error', '暂无退款权限，请联系超管开启')
            }
            this.isShowRefundDialog = true
        },
        // 退款确认回调
        refundConfirm(resolve, reject) {
            // 退款的接口
            $fetch.post({
                url: '/order/refundorder',
                params: {
                    order_type: this.rowData.payment_method,
                    order_id: this.rowData.id,
                    refund_money: +this.rowData.actual_payment
                }
            }).then(() => {
                resolve()
                this.$emit('update:visible')
                this.$emit('refund-success')
            }).catch(reject)
        },
        getPaymentByType(type) {
            return this.rowData.payments.find(val => val.payment_type === type)
        },

        getUsedPoints() {
            if (this.rowData.points.length == 0) {
                return null
            } else {
                return this.rowData.points.find(val => val.points_type === 1)
            }
        },

        getGiftPoints() {
            if (this.rowData.points.length == 0) {
                return null
            } else {
                return this.rowData.points.find(val => val.points_type === 0)
            }
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.isLoading = false
                this.isExpandTable = false
                this.isShowRefundDialog = false
                this.rowData = null
                console.log(this.orderNo)
                this.getOrderFormList()
            }
        }
    },
    components: {
        SideContainer,
        OrderFormTemplate,
        RefundDialog,
        OrderFormItem
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
    td {
        border-color: transparent;
    }

    .el-table__empty-block {
        display: none;
    }

    .el-table__append-wrapper {
        .el-table {
            margin-top: 0 !important;

            &::before {
                background-color: transparent;
            }

            .el-table__body-wrapper {
                border: none !important;
            }
        }
    }
}

.fx-v-center {
    display: flex;
    align-items: center;
}

.no-participate-text {
    margin-top: 12px;

    span {
        position: relative;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        padding: 0 6px;
        background-color: #f7f7f7;
        border-radius: 10px;

        &::before {
            content: '';
            position: absolute;
            left: -84px;
            top: 50%;
            transform: translateY(-50%);
            width: 74px;
            height: 2px;
            border-radius: 1px;
            background: linear-gradient(to right, #fff 0%, #f0f0f0 100%);
        }

        &::after {
            content: '';
            position: absolute;
            right: -84px;
            top: 50%;
            transform: translateY(-50%);
            width: 74px;
            height: 2px;
            border-radius: 1px;
            background: linear-gradient(to left, #fff 0%, #f0f0f0 100%);
        }
    }
}

.section {
    position: relative;
    padding: 12px;

    .iconyituikuan {
        position: absolute;
        top: 34px;
        right: 8px;
        font-size: 72px;
        color: #F7ADAD;
        z-index: 3;
    }

    .user-info-and-time {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time {
            font-size: 14px;
            color: #333;
        }
    }

    .pay-real-pay {
        height: 70px;
        padding: 14px 12px 12px;
        box-sizing: border-box;

        &:hover {
            background: #f7f7f7;
        }

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 22px;

            span {
                font-size: 14px;
                color: #333;

                &:last-child {
                    font-size: 16px;
                    color: #009688;
                }
            }
        }

        .bottom {
            display: flex;
            justify-content: flex-end;
            line-height: 16px;
            margin-top: 6px;
            font-size: 12px;
            color: #666;

            span + span {
                margin-left: 20px;
            }
        }
    }

    .table-append-more-than-five {
        display: flex;
        justify-content: space-between;
        height: 44px;
        line-height: 44px;
        padding: 0 10px;
        border-top: 1px solid #ebebeb;

        .see-more {
            font-size: 12px;
            color: #999;
            cursor: pointer;
        }

        .icongonggongxia1,
        .icongonggongshang1 {
            font-size: 12px;
        }
    }

    .iconjian {
        margin-right: 6.2px;
        color: #EA4F18;
    }

    .all-youhui {
        font-size: 16px;
        color: #333;

        &-money {
            margin-left: 20px;
        }
    }

    .notes {
        padding: 10px 12px;
        font-size: 14px;
        color: #E51C23;
        line-height: 20px;
        background: #F7F7F7;
    }
}

.show-bottom-dashed-border {
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: -0.5px;
        border-bottom: 1px dashed #EBEBEB;
    }
}

.footer-btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 12px;
    font-size: 14px;
    color: #E51C23;
    cursor: pointer;

    .icontuikuan {
        margin-bottom: 2.2px;
    }
}

.point-bg {
    padding: 2px 8px;
    background-image: url("~@/assets/images/a5.svg");
    background-size: 100% 100%;
}

 .member-price {
    text-align: center;

    .iconhuiyuanjia {
        margin-right: 3px;
        font-size: 12px;
        color: #8D6549;
    }

    .under-line {
        color: #999;
        text-decoration: line-through;
        font-size: 12px;
    }
}
</style>
